<div class="cm-variations-container">
    <div class="cm-mode-toggle">
        <button class="cm-mode-option" [class.cm-selected]="$mode() === 'fullFrames'" (click)="$mode.set('fullFrames')">Full Frames</button>
        <button class="cm-mode-option" [class.cm-selected]="$mode() === 'layers'" (click)="$mode.set('layers')">Layers</button>
    </div>

    <div class="cm-render-actions">
        @if ($mode() === "layers") {
            <cm-button class="cm-render" [disabled]="$renderAllLayersDisabled()" [class.cm-disabled]="$renderAllLayersDisabled()" (click)="renderAllLayers()">
                <ng-container cm-left-icon>
                    <i class="fa-solid fa-image"></i>
                </ng-container>
                <ng-container cm-text> Render All</ng-container>
            </cm-button>
            <cm-button
                class="cm-render"
                [disabled]="$downloadAllLayersDisabled()"
                [class.cm-disabled]="$downloadAllLayersDisabled()"
                [matMenuTriggerFor]="downloadAllLayersMenu"
            >
                <ng-container cm-left-icon>
                    <i class="fa-solid fa-save"></i>
                </ng-container>
                <ng-container cm-text> Download All</ng-container>
                <mat-menu #downloadAllLayersMenu>
                    <ng-template matMenuContent>
                        <button mat-menu-item matTooltip="Post-processed, stack in the numbered order with normal blending" (click)="downloadAllLayers('png')">
                            PNG
                        </button>
                        <button mat-menu-item matTooltip="Post-processed, stack in the numbered order with normal blending" (click)="downloadAllLayers('tiff')">
                            TIFF
                        </button>
                        <button mat-menu-item matTooltip="Linear and unprocessed, assemble with Add in any order" (click)="downloadAllLayers('exr')">
                            EXR (linear)
                        </button>
                    </ng-template>
                </mat-menu>
            </cm-button>
            <cm-button
                class="cm-delete-button"
                [disabled]="$discardAllLayersDisabled()"
                [class.cm-disabled]="$discardAllLayersDisabled()"
                (click)="discardAllLayers()"
            >
                <ng-container cm-left-icon>
                    <i class="far fa-trash"></i>
                </ng-container>
            </cm-button>
        } @else {
            <cm-button class="cm-render" [disabled]="$renderAllDisabled()" [class.cm-disabled]="$renderAllDisabled()" (click)="renderAll()">
                <ng-container cm-left-icon>
                    <i class="fa-solid fa-image"></i>
                </ng-container>
                <ng-container cm-text> Render All</ng-container>
            </cm-button>
            <cm-button class="cm-render" [disabled]="$downloadAllDisabled()" [class.cm-disabled]="$downloadAllDisabled()" [matMenuTriggerFor]="downloadAllMenu">
                <ng-container cm-left-icon>
                    <i class="fa-solid fa-save"></i>
                </ng-container>
                <ng-container cm-text> Download All</ng-container>
                <mat-menu #downloadAllMenu>
                    <ng-template matMenuContent>
                        <button mat-menu-item (click)="downloadAll('image/png')">PNG</button>
                        <button mat-menu-item (click)="downloadAll('image/jpeg')">JPEG</button>
                        <button mat-menu-item (click)="downloadAll('image/tiff')">TIFF</button>
                        <button mat-menu-item (click)="downloadAll('image/x-exr')">EXR (Raw)</button>
                    </ng-template>
                </mat-menu>
            </cm-button>
            <cm-button class="cm-delete-button" [disabled]="$deleteAllDisabled()" [class.cm-disabled]="$deleteAllDisabled()" (click)="deleteAll()">
                <ng-container cm-left-icon>
                    <i class="far fa-trash"></i>
                </ng-container>
            </cm-button>
        }
    </div>

    @if ($showProgress()) {
        <div class="cm-progress-bar">
            <mat-progress-bar [mode]="$progress() === 0 ? 'indeterminate' : 'determinate'" [value]="$progress()"></mat-progress-bar>
            <button class="cm-cancel-btn" (click)="cancelCurrentOperation()" matTooltip="Cancel current operation">
                <i class="fa-solid fa-times"></i>
            </button>
        </div>
    }
    @if ($analysisStatus(); as analysisStatus) {
        <div class="cm-analysis-status">{{ analysisStatus }}</div>
    }

    @if ($mode() === "fullFrames") {
        @if ($variationSummary(); as summary) {
            <div class="cm-layer-plan">
                <div class="cm-layer-plan-label" matTooltip="Groups whose options vary in the list">Groups</div>
                <div class="cm-layer-plan-groups">
                    @for (group of summary.groups; track group) {
                        <div class="cm-layer-plan-group">
                            <span class="cm-layer-plan-name">{{ group }}</span>
                        </div>
                    }
                </div>
            </div>
            <div class="cm-layer-plan-totals">{{ summary.total }} variations</div>
        }
        <div class="cm-render-stats">{{ $numRendering() }} Rendering / {{ $numRendered() }} Rendered / {{ $numFailed() }} Failed</div>
    } @else {
        @if ($layerPlanUnavailable()) {
            <div class="cm-analysis-status">The structure of this template is not supported by the layer analysis.</div>
        }
        @if ($layerPlanSummary(); as summary) {
            <div class="cm-layer-plan">
                @for (row of summary.rows; track row.label) {
                    <div class="cm-layer-plan-label" [matTooltip]="row.tooltip">{{ row.label }}</div>
                    <div class="cm-layer-plan-groups">
                        @for (group of row.groups; track group.label) {
                            <div class="cm-layer-plan-group" [matTooltip]="group.tooltip">
                                <span class="cm-layer-plan-name">{{ group.label }}</span>
                                @if (group.tag) {
                                    <span class="cm-layer-plan-tag">{{ group.tag }}</span>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
            @for (warning of summary.warnings; track warning) {
                <div class="cm-layer-plan-warning"><i class="fa-solid fa-triangle-exclamation"></i> {{ warning }}</div>
            }
            <div class="cm-layer-plan-totals">
                {{ summary.contextCount }} contexts × {{ summary.layersPerContext }} layers = {{ summary.layerCount }} layer renders
                @if (summary.fullCount; as fullCount) {
                    <br />
                    <span class="cm-layer-plan-none">vs {{ fullCount }} full renders</span>
                }
            </div>
        }
        @if ($layerStats(); as stats) {
            <div class="cm-render-stats">{{ stats.rendering }} Rendering / {{ stats.rendered }} Rendered / {{ stats.failed }} Failed</div>
        }
    }

    @if ($facetGroups(); as facetGroups) {
        @if (facetGroups.length > 0) {
            <div class="cm-facets-header">
                <button class="cm-facets-toggle" (click)="$facetsExpanded.set(!$facetsExpanded())">
                    <i class="fa-solid" [class.fa-chevron-down]="$facetsExpanded()" [class.fa-chevron-right]="!$facetsExpanded()"></i>
                    Filter
                </button>
                @if ($isFiltered()) {
                    <button class="cm-facet-reset" (click)="clearFilter()">Reset filter</button>
                }
            </div>
            @if (!$facetsExpanded()) {
                <div class="cm-facet-options cm-facets-selected">
                    @for (selected of $selectedFacets(); track selected.facet.id) {
                        <button
                            class="cm-facet-option cm-selected"
                            matTooltip="Remove from the filter"
                            (click)="toggleFacet(selected.facet.id, selected.option.id)"
                        >
                            {{ selected.facet.name }}: {{ selected.option.name }} <i class="fa-solid fa-times"></i>
                        </button>
                    } @empty {
                        <span class="cm-facets-none">No filter</span>
                    }
                </div>
            } @else {
                <div class="cm-facets">
                    @for (facet of facetGroups; track facet.id) {
                        @if (facet.sectionTitle) {
                            <div class="cm-facet-section">{{ facet.sectionTitle }}</div>
                        }
                        <div class="cm-facet-group" [class.cm-in-section]="facet.inSection">
                            <div class="cm-facet-name">{{ facet.name }}</div>
                            <div class="cm-facet-options">
                                @for (option of facet.options; track option.id) {
                                    <button
                                        class="cm-facet-option"
                                        [class.cm-selected]="option.selected"
                                        [disabled]="option.disabled"
                                        (click)="toggleFacet(facet.id, option.id)"
                                    >
                                        {{ option.name }} <span class="cm-facet-count" [matTooltip]="facet.countTooltip">{{ option.countLabel }}</span>
                                    </button>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        }
    }

    @if ($mode() === "layers") {
        @if ($layerPlanUnavailable()) {
            <div class="cm-variation-list"></div>
        } @else if (!$layerPlan()) {
            <div class="cm-filler"></div>
            <div class="cm-job-list-title">Contexts</div>
            <div class="cm-variation-list">
                <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
            </div>
        } @else {
            <div class="cm-filler"></div>
            <div class="cm-job-list-title">
                {{ $layerListTitle() }}
                <div class="cm-view-toggle">
                    <button
                        [class.cm-selected]="$contextView() === 'tree' && $contextTreeAvailable()"
                        [disabled]="!$contextTreeAvailable()"
                        [matTooltip]="$contextTreeAvailable() ? 'Tree' : 'The tree is available up to 20,000 contexts'"
                        (click)="$contextView.set('tree')"
                    >
                        <i class="fa-solid fa-sitemap"></i>
                    </button>
                    <button [class.cm-selected]="$contextView() === 'list' || !$contextTreeAvailable()" matTooltip="List" (click)="$contextView.set('list')">
                        <i class="fa-solid fa-list"></i>
                    </button>
                </div>
            </div>
            @if ($layerContextLegend(); as legend) {
                <div class="cm-variation-legend" [matTooltip]="legend">{{ legend }}</div>
            }
            <div class="cm-variation-list" #variationList (scroll)="$variationListScrollTop.set(variationList.scrollTop)">
                <div class="cm-variation-list-spacer" [style.height.px]="$listSpacerHeight()">
                    <div class="cm-variation-list-window" [style.transform]="'translateY(' + $visibleVariationRange().translate + 'px)'">
                        @for (row of $visibleLayerContexts(); track row.key) {
                            @if (row.kind === "caption") {
                                <div class="cm-variation-caption" [style.padding-left.px]="8 + row.indent * 16" [matTooltip]="row.label">{{ row.label }}</div>
                            } @else if (row.kind === "node") {
                                <div
                                    class="cm-variation-section"
                                    [class.cm-current]="row.current"
                                    [style.padding-left.px]="8 + row.indent * 16"
                                    [matTooltip]="row.tooltip"
                                    (click)="toggleContextNode(row.key)"
                                >
                                    <i
                                        class="fa-solid cm-variation-section-chevron"
                                        [class.fa-chevron-down]="row.expanded"
                                        [class.fa-chevron-right]="!row.expanded"
                                    ></i>
                                    <span class="cm-variation-section-label">{{ row.label }}</span>
                                    <span class="cm-variation-section-count">{{ row.countLabel }}</span>
                                </div>
                            } @else {
                                <div class="cm-variation-row" [style.padding-left.px]="row.indent * 16">
                                    <cm-list-item [selected]="row.current" [matTooltip]="row.tooltip" (click)="selectLayer(row.context)">
                                        <ng-container cm-title>
                                            {{ row.label }}
                                        </ng-container>
                                    </cm-list-item>
                                    <div class="cm-variation-list-icons cm-layer-context-count" matTooltip="Rendered layers">
                                        {{ row.renderedCount }} / {{ row.context.layers.length }}
                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
            </div>
        }
    }

    @if (!sidePanelService.$open()) {
        <ng-container [ngTemplateOutlet]="sidePanel"></ng-container>
    }
</div>

<ng-template #sidePanel>
    <div class="cm-side-panel">
        @if ($mode() === "fullFrames") {
            @if ($allVariations(); as allVariations) {
                <div class="cm-filler"></div>
                <div class="cm-job-list-title">
                    Variations ({{ $variationCountLabel() }})
                    <div class="cm-view-toggle">
                        <button [class.cm-selected]="$variationView() === 'tree'" matTooltip="Tree" (click)="$variationView.set('tree')">
                            <i class="fa-solid fa-sitemap"></i>
                        </button>
                        <button [class.cm-selected]="$variationView() === 'list'" matTooltip="List" (click)="$variationView.set('list')">
                            <i class="fa-solid fa-list"></i>
                        </button>
                    </div>
                </div>
                @if ($variationLegend(); as legend) {
                    <div class="cm-variation-legend" [matTooltip]="legend">{{ legend }}</div>
                }
                @if (allVariations.length === 0 && $state() === "loading") {
                    <div class="cm-variation-list">
                        <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
                    </div>
                } @else {
                    <div class="cm-variation-list" #variationList (scroll)="$variationListScrollTop.set(variationList.scrollTop)">
                        <div class="cm-variation-list-spacer" [style.height.px]="$listSpacerHeight()">
                            <div class="cm-variation-list-window" [style.transform]="'translateY(' + $visibleVariationRange().translate + 'px)'">
                                @for (row of $visibleVariationRows(); track row.key) {
                                    @if (row.kind === "caption") {
                                        <div class="cm-variation-caption" [style.padding-left.px]="8 + row.indent * 16" [matTooltip]="row.label">
                                            {{ row.label }}
                                        </div>
                                    } @else if (row.kind === "node") {
                                        <div
                                            class="cm-variation-section"
                                            [class.cm-current]="row.current"
                                            [style.padding-left.px]="8 + row.indent * 16"
                                            [matTooltip]="row.tooltip"
                                            (click)="toggleVariationNode(row.key)"
                                        >
                                            <i
                                                class="fa-solid cm-variation-section-chevron"
                                                [class.fa-chevron-down]="row.expanded"
                                                [class.fa-chevron-right]="!row.expanded"
                                            ></i>
                                            <span class="cm-variation-section-label">{{ row.label }}</span>
                                            <span class="cm-variation-section-count">{{ row.countLabel }}</span>
                                        </div>
                                    } @else {
                                        <div class="cm-variation-row" [style.padding-left.px]="row.indent * 16">
                                            <cm-list-item
                                                [selected]="row.variation.hash === $currentLocalConfigurationHash() && $selectedUnassignedJob() === undefined"
                                                [matTooltip]="row.variation.name"
                                                (click)="setConfiguration(row.variation)"
                                            >
                                                <ng-container cm-title>
                                                    {{ row.label }}
                                                </ng-container>
                                            </cm-list-item>
                                            <div class="cm-variation-list-icons">
                                                @if (row.variation.render; as render) {
                                                    <cm-template-job-icon [job]="render"></cm-template-job-icon>
                                                } @else {
                                                    <i class="far fa-circle cm-not-rendered" matTooltip="Not rendered"></i>
                                                }
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                }
            }
            @if ($unassignedJobs(); as unassignedJobs) {
                @if (unassignedJobs.length > 0) {
                    <div class="cm-filler"></div>
                    <div class="cm-job-list-title">Unassigned Renders ({{ unassignedJobs.length }})</div>
                    <div class="cm-unassigned-job-list">
                        @for (unassignedJob of unassignedJobs; track unassignedJob.job.id) {
                            <cm-list-item
                                [selected]="unassignedJob.job.id === $selectedUnassignedJob()?.job?.id"
                                [matTooltip]="unassignedJob.displayName"
                                (click)="selectUnassignedJob(unassignedJob)"
                            >
                                <ng-container cm-title>
                                    {{ unassignedJob.displayName }}
                                </ng-container>
                            </cm-list-item>
                            <div class="cm-unassigned-job-list-icons">
                                <cm-template-job-icon [job]="unassignedJob.job"></cm-template-job-icon>
                            </div>
                        }
                    </div>
                }
            }
        } @else {
            @if ($currentContextLayers(); as layers) {
                <div class="cm-filler"></div>
                <div class="cm-job-list-title">Layers of the current context ({{ layers.length }})</div>
                <div class="cm-layer-list">
                    @for (entry of layers; track entry.layer.key) {
                        @if (entry.startsGroup) {
                            <div class="cm-layer-separator"></div>
                        }
                        <cm-list-item [selected]="entry.inStack" [matTooltip]="entry.label" (click)="clickLayer(entry.context, entry.layer)">
                            <ng-container cm-title>
                                {{ entry.label }}
                            </ng-container>
                        </cm-list-item>
                        <div class="cm-layer-list-icons">
                            <button
                                class="cm-solo"
                                [class.cm-active-solo]="entry.solo"
                                [matTooltip]="entry.solo ? 'End solo' : 'Solo: show only this layer in the image viewer'"
                                (click)="toggleSolo(entry.context, entry.layer)"
                            >
                                <i class="fa-solid fa-crosshairs"></i>
                            </button>
                            @if (entry.job; as job) {
                                <cm-template-job-icon [job]="job"></cm-template-job-icon>
                            } @else {
                                <i class="far fa-circle cm-not-rendered" matTooltip="Not rendered"></i>
                            }
                        </div>
                    }
                </div>
            } @else if (!$layerPlan() && !$layerPlanUnavailable()) {
                <div class="cm-filler"></div>
                <div class="cm-job-list-title">Layers of the current context</div>
                <div class="cm-layer-list">
                    <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
                </div>
            }

            @if ($unreferencedLayerJobs(); as unreferenced) {
                @if (unreferenced.length > 0) {
                    <div class="cm-filler"></div>
                    <div class="cm-job-list-title">Unreferenced Layers ({{ unreferenced.length }})</div>
                    <div class="cm-unassigned-job-list">
                        @for (entry of unreferenced; track entry.key) {
                            <cm-list-item [matTooltip]="entry.label">
                                <ng-container cm-title>
                                    {{ entry.label }}
                                </ng-container>
                            </cm-list-item>
                            <div class="cm-unassigned-job-list-icons">
                                <cm-template-job-icon [job]="entry.job"></cm-template-job-icon>
                            </div>
                        }
                    </div>
                }
            }
        }
    </div>
</ng-template>
